<template>
  <NuxtLayout class="antialiased font-body text-neutral-10">
    <NuxtPage />
    <IadNotifications class="print:hidden non-dialog-notifications" />
  </NuxtLayout>
</template>

<style>
:where(.iconify) {
  fill: currentColor;
}
/*
  This is mainly useful on windows to prevent the scrollbar from jumping when the dialog is opened.
  https://developer.mozilla.org/en-US/docs/Web/CSS/scrollbar-gutter
*/
html, body {
  scrollbar-gutter: stable;
}
html:has(dialog[open]) {
  overflow: hidden;

  /*
    Since <dialog> create their own display stack:
    • we need to display them “inside” the <dialog> element
    • we need to remove this one to avoid “double shadow” on big screens
  */
  & .non-dialog-notifications {
    display: none !important;
  }
}

/* Prevent Chrome to autofill in lightblue when users browses and selectes autocomplete suggestions on inputs */
input:-webkit-autofill {
  background-color: white !important;
  box-shadow: 0 0 0 30px white inset !important;
}
</style>
